import { decryptData } from '@/components/reusable/crypto/Cipher';
import { decodeBase64 } from '@/utils/common';
import Cookies from 'js-cookie';

/**
 * retrieve admin token
 * return token form sessionStorage
 * @returns
 */

const useAdminToken = () => {
  try {
    // const token = sessionStorage.getItem('admin_token');
    // const token = Cookies.get('admin_token') || Cookies.get('superadmin_token');
    const token = Cookies.get('token');
    if (!token) return null;
    return decryptData(token);
  } catch (error) {
    throw new Error(error);
  }
};

export default useAdminToken;
